import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import prepareAuthHeaders from "@utils/prepareAuthHeaders";
import { User } from "@models/user";

const BASE_API_URL = process.env.REACT_APP_API_URL;

export const userApi = createApi({
  reducerPath: "userApi",
  tagTypes: ["User"],
  baseQuery: fetchBaseQuery({
    baseUrl: `${BASE_API_URL}/users`,
    prepareHeaders: prepareAuthHeaders,
  }),
  endpoints: (builder) => ({
    updateUser: builder.mutation<User, Partial<User>>({
      invalidatesTags: ["User"],
      query: (user: Partial<User>) => {
        return {
          url: "",
          method: "PATCH",
          body: user,
        };
      },
    }),
    getUser: builder.query<User, void>({
      providesTags: ["User"],
      query: () => {
        return {
          url: "",
          method: "GET",
        };
      },
    }),
  }),
});

export const { useUpdateUserMutation, useGetUserQuery } = userApi;
